function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { clsx as s } from "./index.es105.js";
import "./index.es93.js";
import "./index.es94.js";
import "./index.es95.js";
import "./index.es96.js";
import "./index.es97.js";
import "./index.es98.js";
import "./index.es99.js";
import "./index.es100.js";
import "./index.es101.js";
import "./index.es102.js";
import "./index.es103.js";
import "./index.es104.js";
import { palette as h } from "./index.es36.js";
import t from "./index.es124.js";
import l from "./index.es111.js";
var B = function B(_ref) {
    var r = _ref.autoHeight,
      o = _ref.isAutosize,
      e = _ref.minHeight,
      p = _ref.maxHeight,
      m = _ref.height,
      i = _ref.withCopy,
      u = _ref.isDisabled;
    var n = function n(a) {
      return a && a - 2;
    };
    return {
      height: n(r || m),
      minHeight: o ? "auto" : n(e),
      maxHeight: o ? "auto" : n(p),
      color: i && u ? h.gray10 : void 0
    };
  },
  T = function T(_ref2) {
    var r = _ref2.autoHeight,
      o = _ref2.height,
      e = _ref2.minHeight,
      p = _ref2.maxHeight,
      m = _ref2.isVariable;
    return {
      overflow: m ? "visible" : p && r >= p ? "auto" : "hidden",
      height: "".concat(Math.min(r || Number(o), Number(p)) - 2, "px"),
      "--input-inner-height": "".concat(Math.max(r || Number(o), Number(e)) - 2, "px")
    };
  },
  W = function W(_ref3) {
    var r = _ref3.isVariable,
      o = _ref3.isAutosize,
      e = _ref3.withCopy,
      p = _ref3.isDisabled,
      m = _ref3.isControl,
      i = _ref3.bothControls;
    return {
      wrapperClassName: s(t.inputWrapper, _defineProperty(_defineProperty(_defineProperty({}, t.variable, r), t.autoSizeInput, o), t.bothControls, i)),
      textAreaClassName: s(l.input, t.input, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, t.autoSizeInput, o), l.withCopyIcon, e && p), t.variable, r), t.withControl, m), t.bothControls, i))
    };
  };
export { W as getInputClassNames, T as getTextAreaStyles, B as textAreaStyles };